import { Action, RequestStatus, UseCaseStateGenerator } from '@lib/plugin-redux-core';
import {
  EXPORT_OFFLINE_FORM_USE_CASE,
  ExportOfflineFormUseCaseOutput,
  GET_OFFLINE_EXPORT_PLAN_USE_CASE,
  GetOfflineExportPlanUseCaseOutput,
} from '@module/form';
import { FormEditPageState } from '../form-edit.states';

const matchesPlanRequest = (state: FormEditPageState, action: Action): boolean =>
  Boolean(
    state.getOfflineExportPlanRequestId &&
    action.meta?.input?.requestId === state.getOfflineExportPlanRequestId,
  );

const matchesExportRequest = (state: FormEditPageState, action: Action): boolean =>
  Boolean(
    state.exportOfflineFormRequestId &&
    action.meta?.input?.requestId === state.exportOfflineFormRequestId,
  );

export const exportOfflineFormHandlers: UseCaseStateGenerator<FormEditPageState>[] = [
  {
    name: EXPORT_OFFLINE_FORM_USE_CASE,
    executing: (state: FormEditPageState, action: Action): FormEditPageState => ({
      ...state,
      exportOfflineFormStatus: RequestStatus.EXECUTE,
      exportOfflineFormRequestId: action.payload?.requestId || null,
      exportOfflineFormResult: null,
      exportOfflineFormError: null,
    }),
    success: (state: FormEditPageState, action: Action): FormEditPageState => {
      if (!matchesExportRequest(state, action)) return state;
      return {
        ...state,
        exportOfflineFormStatus: RequestStatus.SUCCESS,
        exportOfflineFormResult: action.payload as ExportOfflineFormUseCaseOutput,
        exportOfflineFormError: null,
      };
    },
    error: (state: FormEditPageState, action: Action): FormEditPageState => {
      if (!matchesExportRequest(state, action)) return state;
      return {
        ...state,
        exportOfflineFormStatus: RequestStatus.ERROR,
        exportOfflineFormResult: null,
        exportOfflineFormError: action.error || null,
      };
    },
    reset: (state: FormEditPageState): FormEditPageState => ({
      ...state,
      exportOfflineFormStatus: RequestStatus.RESET,
      exportOfflineFormRequestId: null,
      exportOfflineFormResult: null,
      exportOfflineFormError: null,
    }),
  },
  {
    name: GET_OFFLINE_EXPORT_PLAN_USE_CASE,
    executing: (state: FormEditPageState, action: Action): FormEditPageState => ({
      ...state,
      getOfflineExportPlanStatus: RequestStatus.EXECUTE,
      getOfflineExportPlanRequestId: action.payload?.requestId || null,
      getOfflineExportPlanResult: null,
      getOfflineExportPlanError: null,
    }),
    success: (state: FormEditPageState, action: Action): FormEditPageState => {
      if (!matchesPlanRequest(state, action)) return state;
      return {
        ...state,
        getOfflineExportPlanStatus: RequestStatus.SUCCESS,
        getOfflineExportPlanResult: action.payload as GetOfflineExportPlanUseCaseOutput,
        getOfflineExportPlanError: null,
      };
    },
    error: (state: FormEditPageState, action: Action): FormEditPageState => {
      if (!matchesPlanRequest(state, action)) return state;
      return {
        ...state,
        getOfflineExportPlanStatus: RequestStatus.ERROR,
        getOfflineExportPlanResult: null,
        getOfflineExportPlanError: action.error || null,
      };
    },
    reset: (state: FormEditPageState): FormEditPageState => ({
      ...state,
      getOfflineExportPlanStatus: RequestStatus.RESET,
      getOfflineExportPlanRequestId: null,
      getOfflineExportPlanResult: null,
      getOfflineExportPlanError: null,
    }),
  },
];
